<template>
    <form @submit.prevent="onClickSubmit">
        <div class="form-import">
            <message
                v-if="isError"
                :text="textError" 
            />
            <drop
                @drop="handleDrop" 
                class="form-import__drag-drop"
            >
                <div>
                    <div>{{fileName}}</div>
                    <div class="form-import__input-file">
                        <input 
                            type="file" 
                            :accept="accept"
                            @change="onInputFile"
                        >
                    </div>
                </div>
            </drop>
            <div class="form-import__btn-container">
              <label>
                <input
                    type="checkbox"
                    v-model="isNotClear"
                >
                Не стирать предыдущие данные
              </label>

            </div>
            <div class="form-import__btn-container">
                <button
                    type="submit"
                    class="btn_default"
                    :class="{'preloader-content': isPreloader}"
                >
                    Загрузить
                    <div
                        v-if="isPreloader"
                        class="fa fa-circle-o-notch fa-spin"
                    >
                    </div>
                </button>
                <a
                        style="margin-left: 10px"
                        @click="onClickUploadLastSlice"
                        class="btn_default"
                        :class="{'preloader-content': isPreloader}"
                >
                    Загрузить из последнего среза
                    <div
                            v-if="isPreloader"
                            class="fa fa-circle-o-notch fa-spin"
                    >
                    </div>
                </a>
            </div>
        </div>
    </form>
</template>

<script>
import { Drop } from 'vue-drag-drop';
import Message from '../Base/Message';
export default {
    name: 'FormImport',
    components: {
        Drop,
        Message
    },
    /**
     * Входные данные компонента
     * @property {array} validateTypes - допустимые типы файлов
     * @property {boolean} isPreloader - условие показа прелоадера
     *
     */
    props: {
        validateTypes: {
            types: Array,
            default: () => ([])
        },
        isPreloader: {
            types: Boolean,
            default: false
        }
    },
    /**
     * Данные компонента
     * @property {object} file - файл
     * @property {boolean} isError - флаг для показа информационного окна с ошибкой
     * @property {string} textError - текст ошибки
     * @property {boolean} isNotClear - очищать старые данные
     */
    data: () => ({
        file: null,
        isError: false,
        textError: '',
        isNotClear: false
    }),
    computed: {
        /**
         * Название файла
         * @returns {string} 
         */
        fileName() {
            let name = (this.file === null) ? "Перетащите файл сюда или" : this.file.name;
            return name;
        },
        /**
         * допустимые типы файлов
         * @returns {string}
         */
        accept() {
            let accept = this.validateTypes.join(', ');
            return accept;
        }
    },
    methods: {
        /**
         * событие drop
         * @param {object} data - данные
         * @param {object} event - объект события
         */
        handleDrop(data, event) {
            event.preventDefault();
            let file = event.dataTransfer.files[0];
            // let {type} = file;
            // if (this.validateTypes.includes(type)) {
                this.isError = false;
                this.textError = '';
                this.file = file;
            // }
            // else {
            //     this.file = null;
            //     this.isError = true;
            //     this.textError = "недопустимый файл";
            // }
        },
        /**
         * событие загрузки файла
         * @param {object} event - объект события
         */
        onInputFile(event) {
            this.file = event.target.files[0];
        },
        /**
         * событие отправки формы
         */
        onClickSubmit() {
            if (this.file === null) {
                this.isError = true;
                this.textError = "вы не прикрепили файл";
            }
            else {
                this.isError = false;
                this.textError = '';

                let formData = new FormData();
                formData.append('file', this.file);
                this.$emit('onClickSubmit', formData, this.isNotClear);
            }
        },
        /**
         * событие клика по кнопке загрузить
         */
        onClickUploadLastSlice() {
            this.$emit('onClickUploadLastSlice');
        }
    }
}
</script>

<style lang="scss" scoped>
    .form-import__drag-drop {
        height: 200px;
        border: 4px dashed #e8f0fe;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .form-import__btn-container {
        margin-top: 10px;
    }
</style>
